var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-button-container", class: _vm.showCheckout() },
    [
      _vm.hasItems()
        ? _c(
            "div",
            { staticClass: "checkout-button-container" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button button--cart",
                  attrs: { to: "/checkout" }
                },
                [
                  _c("BaseIcon", {
                    attrs: {
                      className: ["icon", "cart"],
                      icon: "cartIcon",
                      size: "lg"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-count-background" }, [
                    _c("span", { staticClass: "item-count" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.itemCount) + "\n\t\t\t\t"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7853631a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7853631a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/CheckoutButton.vue
// module id = null
// module chunks = 